<template>
  <div class="walletConnect">
    <w3m-button :label="$t('meau.link')" />
  </div>
</template>

<script setup>
  import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi'
  import { useStore } from "vuex"
  // import { mainnet, arbitrum, bsc, okc } from 'viem/chains'
  import { reconnect,  http, watchConnections } from '@wagmi/core'
  import { mainnet, bsc, okc } from '@wagmi/core/chains'
  import { getKycInfo, getInviteCode } from '@/api'
  const store = useStore()

  // 1. Define constants
  const projectId = 'b4e41353f250958b0c77472ed603222a'
  // 2. Create wagmiConfig
  const metadata = {
    name: 'Web3Modal',
    description: 'Web3Modal Example',
    url: 'http://localhost:8090/', // origin must match your domain & subdomain
    icons: ['https://avatars.githubusercontent.com/u/37784886']
  }
  const chains = [
    // mainnet, 
    bsc, 
    // okc
  ]
  const config = defaultWagmiConfig({
    chains,
    projectId,
    metadata,
    transports: {
      // [mainnet.id]: http(),
      [bsc.id]: http(),
      // [okc.id]: http(),
    }
  })
  store.commit('setConfig', config)
  try {
    reconnect(config).then( async res => {
      if (res.length) {
        store.commit('setConnectWallet', res[0].accounts[0])
        try {
          const userinfo = await getKycInfo({wallet: res[0].accounts[0]})
          if (userinfo.success) {
            store.commit('setUserInfo', userinfo.data)
          }
          const getcode = await getInviteCode({wallet: res[0].accounts[0]})
          if (getcode.success) {
            store.commit('setInviteCode', getcode.data)
          }
        } catch (error) {
          console.log(error, 'getKycInfo');
        }
      } else {
        store.commit('setConnectWallet', '')
        store.commit('setUserInfo', {}) 
        store.commit('setInviteCode', {})
      }
    })
    watchConnections(config, {
      async onChange(data) {
        if (data.length) {
          store.commit('setConnectWallet', data[0].accounts[0])
          try {
            const userinfo = await getKycInfo({wallet: data[0].accounts[0]})
            if (userinfo.success) {
              store.commit('setUserInfo', userinfo.data)
            }
            const getcode = await getInviteCode({wallet:  data[0].accounts[0]})
            if (getcode.success) {
              store.commit('setInviteCode', getcode.data)
            }
          } catch (error) {
            console.log(error, 'getKycInfo');
          }
        } else {
          store.commit('setConnectWallet', '')
          store.commit('setUserInfo', {})
        store.commit('setInviteCode', {})
        }
      },
    })
    // 3. Create modal
    createWeb3Modal({
      wagmiConfig: config,
      projectId,
      enableAnalytics: true, // Optional - defaults to your Cloud configuration
      enableOnramp: true // Optional - false as default
    })
  } catch (error) {
    console.log(error, 'error');
  }
  
</script>
